import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { api } from "@/lib/api";

export default function Packages() {
  const [items, setItems] = useState([]);
  const [cat, setCat] = useState("All");
  useEffect(() => { api.get("/packages").then((r) => setItems(r.data)); }, []);
  const categories = useMemo(() => ["All", ...Array.from(new Set(items.map((i) => i.category)))], [items]);
  const filtered = cat === "All" ? items : items.filter((i) => i.category === cat);

  return (
    <div data-testid="packages-page">
      <section className="hero-bg py-12">
        <div className="container-x">
          <span className="font-cursive text-2xl text-brand-purple">Health Packages</span>
          <h1 className="text-4xl sm:text-5xl font-bold">Affordable, comprehensive checkups</h1>
        </div>
      </section>
      <section className="container-x py-10">
        <div className="flex flex-wrap gap-2 mb-8" data-testid="pkg-filters">
          {categories.map((c) => (
            <button key={c} onClick={() => setCat(c)}
              className={`px-4 py-1.5 text-sm rounded-full border ${cat === c ? "bg-brand-purple text-white border-brand-purple" : "bg-white border-slate-200 text-slate-700"}`}
              data-testid={`pkg-cat-${c.toLowerCase().replace(/\s+/g, "-")}`}>{c}</button>
          ))}
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {filtered.map((p) => (
            <div key={p.id} className="card-clean p-6 flex flex-col" data-testid={`pkg-${p.id}`}>
              <div className="text-xs text-brand-green font-semibold uppercase tracking-wider">{p.category}</div>
              <div className="font-bold text-xl mt-1">{p.name}</div>
              <div className="text-3xl font-bold text-brand-purple mt-3">₹{p.price.toLocaleString("en-IN")}</div>
              <ul className="text-sm text-slate-600 mt-3 space-y-1.5 flex-1">
                {p.tests.map((t, i) => <li key={i} className="flex gap-2"><Check className="h-4 w-4 text-brand-green shrink-0 mt-0.5" />{t}</li>)}
              </ul>
              <Link to={`/book-appointment?package=${encodeURIComponent(p.name)}`} className="btn-primary mt-5 justify-center" data-testid={`pkg-book-${p.id}`}>Book Package</Link>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
